export class Cidade {

  Id: number;
  Descricao: string;
  UF: string;

  constructor() {
    this.Id = 0;
    this.Descricao = '';
    this.UF = '';
  }
}
